export default {
    namespaced: true,
    state: {
        mainData: {},
        templateClass: '',
        templateFormId:null,
        step: null,
    },
    getters: {
        getTemplateClass: state => state.templateClass,
        getMainData: state => state.mainData,
        getTemplateFormId: state => state.templateFormId,
        getStep: state => state.step
    },
    mutations: {
        setMainData:(state, value) => state.mainData = value,
        setTemplateClass: (state, value) => state.templateClass = value,
        setTemplateFormId: (state, value) => state.templateFormId = value,
        setStep: (state, value) => state.step = value,
    },
}